import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/ajustes/impuesto';
import Impuesto from './ImpuestoList';


const ms2p = (state) => {
  return {
    ...state.impuesto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Impuesto);
